import { formatStatus } from "@/features/person/utils/utils";
import { isBeforeToday, toFormat } from "@/lib/dateHelpers";
import { getSectionName } from "@/pages/people/_utils";
import type { Band } from "@/types";

export const formatMembershipHistoryTableData = (bands: Band[]) =>
  bands.map((band) => ({
    id: band.id,
    section: getSectionName(band),
    isPrimarySectionAffiliation: band?.sectionAffiliation?.primary,
    program: band?.programType?.name,
    classification: band?.classification?.name,
    startDate: toFormat(band.startedOn),
    endDate: toFormat(band.expiresOn),
    startDateRaw: band.startedOn,
    endDateRaw: band.expiresOn,
    terminatesOn: band.terminatesOn,
    terminationDate: band.terminatesOn ? toFormat(band.terminatesOn) : null,
    startReason: band.createdReason ? formatStatus(band.createdReason) : null,
    terminationReason: band.terminatedReason ? formatStatus(band.terminatedReason) : null,
    notes: band.notes || []
  }));

export type MembershipHistoryRow = ReturnType<typeof formatMembershipHistoryTableData>[0];

export const isMembershipBandEnded = (row: MembershipHistoryRow): boolean => {
  return isBeforeToday(row.terminatesOn) || isBeforeToday(row.endDateRaw);
};
